//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Button, Grid, InputLabel, TextField, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

import { theme } from '@react/components/theme'
import { erc20WeiToCommaDecString } from '@shared/conversions'

import { AddressPill } from '@react/components/addresses/AddressPill'
import { TableHeaderItem } from '@react/components/TableHeaderItem'
import { useOtDispatch } from '@react/redux/store'
import { changeWithdrawDestinationTx } from '@react/signedTxs/changeWithdrawDestinationTx'
import { logOT } from '@shared/loggingShared'
import { DynamicWithdrawalActivityCTO } from '@shared/sharedTypes'
import { ZeroAddress } from 'ethers'

export default function AdminDynamicWithdrawDestinationChangeForm(props: {
  activity: DynamicWithdrawalActivityCTO
  symbol: string
  liquidityTokenSymbol: string
}): ReactElement {
  const { activity, symbol, liquidityTokenSymbol } = props
  const { lender, assets, shares } = activity

  const dispatch = useOtDispatch()
  const [destination, setDestination] = React.useState<string>(lender)
  const [errorDestination, _setErrorDestination] = React.useState<string | undefined>(undefined)

  const [isSubmitted, setIsSubmitted] = React.useState(false)

  const sx = {
    backgroundColor: theme.palette.fg.main,
    color: '#FFFFFF',
    padding: '11px 16px 11px 16px',
    marginLeft: '8px',
    borderRadius: '6px',
    marginTop: 2,
  }

  const handleOnFocusDestination = (_: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {}
  const handleOnBlurDestination = (_: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {}
  const handleOnChangeDestination = (event: React.ChangeEvent<HTMLInputElement>): void => {
    logOT.debug('handleOnChange', event.target.value)

    setDestination(event.target.value)
  }
  const setDestinationActionToZero = (): void => {
    setDestination(ZeroAddress)
  }
  const setDestinationAction = (): void => {
    setIsSubmitted(true)
    dispatch(
      changeWithdrawDestinationTx({
        activity,
        destination,
      })
    )
    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }
  const disableButton = false
  return (
    <div data-testid="REPAY_EARLY_REDEEM_FORM">
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Typography variant="body" align="left" sx={{ marginBottom: 2 }}>
            TODO Change this to a pick list of legal addresses
          </Typography>
        </Grid>
      </Grid>

      {activity && (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TableHeaderItem>Lender</TableHeaderItem>
            </Grid>
            <Grid item xs={4}>
              <TableHeaderItem>Shares</TableHeaderItem>
            </Grid>
            <Grid item xs={4}>
              <TableHeaderItem>Asset Value({liquidityTokenSymbol})</TableHeaderItem>
            </Grid>
          </Grid>

          <Grid container sx={{ marginBottom: 4 }}>
            <Grid item xs={4}>
              <Box sx={{ width: '75%' }}>
                <AddressPill addr={lender} />
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={{ marginLeft: 1 }} variant="bodyBold">
                {erc20WeiToCommaDecString(shares)} {symbol}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={{ marginLeft: 1 }} variant="bodyBold">
                {erc20WeiToCommaDecString(assets)} {liquidityTokenSymbol}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}

      <Grid container sx={{ marginTop: 2 }}>
        <Grid item xs={12}>
          <InputLabel htmlFor="usdc">Destination Wallet for funds</InputLabel>
          <TextField
            id="usdc"
            sx={{ width: '300px' }}
            variant="outlined"
            placeholder="Enter Withdraw Amount"
            value={destination}
            onFocus={handleOnFocusDestination}
            onChange={handleOnChangeDestination}
            onBlur={handleOnBlurDestination}
            helperText={errorDestination}
          />
          <Button
            onClick={() => {
              setDestinationActionToZero()
            }}
          >
            OffChain transfer
          </Button>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Button
            disabled={isSubmitted || disableButton}
            sx={sx}
            onClick={() => {
              setDestinationAction()
            }}
            variant={'contained'}
          >
            <Typography variant={'buttonBold'}>Change Destination</Typography>
          </Button>
        </Grid>
        {disableButton && (
          <Typography variant="body" align="left" sx={{ marginBottom: 2 }}>
            No alternative desinations
          </Typography>
        )}
      </Grid>
    </div>
  )
}
